import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

/**
 * Recupera i parametri essenziali per l'invocazione di servizi OpenServices legacy.
 *
 * Estrae e formatta i dati necessari per autenticare e indirizzare correttamente
 * le chiamate verso i servizi OpenServices esistenti del sistema legacy.
 *
 * La funzione opera esclusivamente in ambiente cloud e:
 * - Estrae l'access token dal JWT globale decodificando la claim `sid`
 * - Normalizza il token rimuovendo caratteri speciali e convertendolo in maiuscolo
 * - Determina l'URL base dall'istanza Axios o dall'origine della finestra corrente
 * - Imposta il descrittore deployment su 'cloud'
 *
 * @returns {object} Parametri per servizi OpenServices legacy
 * @returns {string} returns.accessToken - Token di accesso normalizzato (senza {}, -, maiuscolo)
 * @returns {string} returns.baseUrl - URL base per le richieste API (senza trailing slash)
 * @returns {string} returns._cd - Descrittore deployment fisso ('cloud')
 *
 * @throws {Error} Se il token globale non è disponibile o non è un JWT valido
 */
const getOpenServiceDatas = (): {
  accessToken: string;
  baseUrl: string;
  _cd: string;
} => {
  // Determina l'URL base rimuovendo eventuali trailing slash
  let baseUrl = (axios.defaults.baseURL || window.location.origin).replace(
    /\/$/,
    '',
  );
  //@ts-expect-error - Variabile globale iniettata dall'ambiente cloud
  if (window.VMPath) {
    if (baseUrl.endsWith('/')) {
      //@ts-expect-error - Variabile globale iniettata dall'ambiente cloud
      baseUrl = baseUrl += window.VMPath + '/'; // Aggiunge VMPath se definito
    } else {
      //@ts-expect-error - Variabile globale iniettata dall'ambiente cloud
      baseUrl = baseUrl += '/' + window.VMPath; // Aggiunge VMPath se definito
    }
  }

  // Estrae e decodifica il JWT dal contesto globale
  //@ts-expect-error - Variabile globale iniettata dall'ambiente cloud
  const token = window.token;

  if (!token) {
    throw new Error('Token globale non disponibile');
  }

  try {
    const decodedJWT = jwtDecode<{ sid: string }>(token);

    if (!decodedJWT.sid) {
      throw new Error('Claim sid mancante nel JWT');
    }

    // Normalizza il SID rimuovendo caratteri speciali e convertendo in maiuscolo
    const accessToken = decodedJWT.sid.replace(/[{}\-]/g, '').toUpperCase();

    return {
      accessToken,
      baseUrl,
      _cd: 'cloud',
    };
  } catch (error) {
    throw new Error(`Errore nella decodifica del JWT: ${error}`);
  }
};

export default getOpenServiceDatas;
